// haulier api
export const depots = '/depots/';

export const locations = '/locations/';
export const location = (id) => `/location/${id}/`;

export const locationsUpload = '/upload_csv/';
export const productsUpload = '/products/upload_csv/';
export const purchaseOrdersUpload = '/purchase_orders/upload_csv/';

export const timewindows = '/timewindows/';
export const allTimewindows = '/timewindows/all/';

export const createOrder = '/create_standalone_order/';
export const deleteOrder = '/delete_standalone_order/';

export const createDeliveryRequest = 'delivery_requests/';

export const deletePurchaseOrders = 'purchase_orders/delete/';
export const archivePurchaseOrders = 'purchase_orders/archive/';
export const unArchivePurchaseOrders = 'purchase_orders/unarchive/';

export const completeRoute = '/route/completed/';

export const products = '/products/';

export const pallets = '/pallets/';

export const solver = '/solve/';

export const storeRequest = (id) => `/stores/${id}/store_requests/`;

// bind map api
export const bingMapDistanceMatrix = `https://dev.virtualearth.net/REST/v1/Routes/DistanceMatrix?key=${process.env.VUE_APP_BING_MAP_API_KEY}`;
